import { render, staticRenderFns } from "./RemovableItem.vue?vue&type=template&id=6e087fe0&"
import script from "./RemovableItem.vue?vue&type=script&lang=js&"
export * from "./RemovableItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports